// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-o_fY","advertDetailServiceList__header":"c-o_fZ","advertDetailServiceList__list":"c-o_ga"};